import { apiClient } from 'api'
import { LeagueDivision } from 'types/league-divisions'

type NewItem = Omit<LeagueDivision, 'id'>

export const getLeagueDivisions = () => apiClient.get<LeagueDivision[]>('/league-divisions')

export const getLeagueDivisionById = (id: number) => apiClient.get<LeagueDivision>(`/league-divisions/${id}`)

export const createLeagueDivision = (item: NewItem) =>
    apiClient.post<NewItem, LeagueDivision>('/league-divisions', item)

export const editLeagueDivision = (item: LeagueDivision) =>
    apiClient.patch<LeagueDivision>(`/league-divisions/${item.id}`, item)

export const deleteLeagueDivision = (id: number) => apiClient.delete(`/league-divisions/${id}`)
